// extracted by mini-css-extract-plugin
export default {"loading":"LoadingScreen_loading__x4Ica","text":"LoadingScreen_text__3DlBJ"};